import axios from "axios";
import { Capacitor } from "@capacitor/core";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Client": Capacitor.isNativePlatform() ? "mobile" : "web",
    "X-Client-Version": process.env.VUE_APP_VERSION,
  },
});

export const AuthService = {
  forgotPassword: ({ email }) => {
    return new Promise((resolve, reject) => {
      http
        .post("/api/v1/passwords/forgot", { email: email })
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },
  resetPassword: ({ token, password }) => {
    return new Promise((resolve, reject) => {
      http
        .post("/api/v1/passwords/reset", {
          token: token,
          password: password,
        })
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },
};
